import styled, { css } from 'styled-components';
import { atPaneWidth } from './paneWidth';
import { Button } from '../../../components/Ant';

export const WeeklyCalendar = styled.div`
  background-color: var(--clr-general-hover);
  border: 1px solid var(--clr-general-border-hover);
  border-radius: 5px;
  padding: 10px;
  width: 100%;
  .calendar-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 10px;
    .ant-btn-text {
      padding: 0;
      font-size: 12px;
      align-items: start;
      &:not(:disabled):not(.ant-btn-disabled):hover {
        background: transparent;
      }
      &:disabled,
      &.ant-btn-disabled {
        color: var(--clr-general-primary);
        opacity: 0.5;
      }
    }
  }
  .week-range {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: var(--clr-title);
    width: 100%;
    min-width: 123px;
  }
  .day {
    text-align: center;
    cursor: pointer;
    padding: 10px 0;
    border-radius: 5px;
    transition: background 0.3s;
    width: 100%;
    flex-shrink: 0;
    max-width: 42px;
    position: relative;
    &:hover {
      background: rgba(var(--clr-general-primary-rgb), 0.2);
    }
    &.today {
      background-color: rgba(var(--clr-general-primary-rgb), 0.2);
    }
    &.selected {
      background-color: var(--clr-general-primary);
      .weekday {
        color: var(--clr-white);
      }
      .day-number {
        color: var(--clr-white);
      }
      .activity {
        background-color: var(--clr-white);
      }
    }
    .weekday {
      font-size: 12px;
      line-height: 18px;
      color: var(--clr-title);
    }
    .day-number {
      font-weight: 500;
      line-height: 21px;
      color: var(--clr-title);
      font-size: 14px;
      position: relative;
    }
    .activity {
      display: inline-block;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: var(--clr-title);
      position: absolute;
      transform: translate(-50%, -50%);
      bottom: 7px;
      left: 21px;
    }
  }
  .days-container {
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    width: 100%;
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
      background: transparent;
    }
  }

  .days-scroll-wrapper {
    position: relative;
    display: flex;
    align-items: center;

    .scroll-arrow {
      width: 14px;
      height: 61px;
      border-radius: 5px;
      padding: 0;
      cursor: pointer;
      &:not(:disabled):not(.ant-btn-disabled):hover {
        .icon {
          color: var(--clr-general-primary);
        }
      }

      &.left {
        left: 0;
      }

      &.right {
        right: 0;
      }

      .icon {
        font-size: 14px;
        color: var(--clr-general-primary);
      }
    }

    ${atPaneWidth(
      'min-width',
      400,
      css`
        .scroll-arrow {
          display: none;
        }
      `,
    )}
  }
`;

export const StepButton = styled(Button)`
  padding: 0;
  background: var(--clr-container-bg);
  &.ant-btn-icon-only {
    width: 36px;
  }
  height: 36px;
  .ant-btn-icon {
    font-size: 18px;
    color: var(--clr-general-primary);
  }
  &:not(:disabled):not(.ant-btn-disabled):hover {
    .ant-btn-icon {
      color: var(--clr-white);
    }
  }
`;
